import HeroSection from "@/components/HeroSection";
import SortimentSection from "@/components/SortimentSection";
import FrischeSection from "@/components/FrischeSection";
import AboutSection from "@/components/AboutSection";
import InfoSection from "@/components/InfoSection";
import Seo from "@/components/Seo";

const Home = () => (
  <>
      <Seo title="Rewe Kotlarski | Ihr Markt in Meerbusch-Osterath" description="Rewe Kotlarski in Meerbusch-Osterath: kleiner Markt mit familiärer Atmosphäre, frischem Sortiment, regionalen Produkten und persönlichem Service." />
    <HeroSection />
    <SortimentSection />
    <FrischeSection />
    <AboutSection />
    <InfoSection />
  </>
);

export default Home;